import axios from 'axios';

const CACHE_EXPIRY_MS = 1 * 60 * 60 * 1000; // 1 hour in milliseconds
const GRAVATAR_API_BASE = 'https://api.gravatar.com/v3/profiles/';

export default async function getGravatarData(profileIdentifier) {
    try {
        if (!profileIdentifier) return;

        const cacheKey = `gravatarProfile-${profileIdentifier}`;
        const cachedEntry = localStorage.getItem(cacheKey);

        if (cachedEntry) {
            const { profile, timestamp } = JSON.parse(cachedEntry);
            if (Date.now() - timestamp < CACHE_EXPIRY_MS) {
                return profile;
            }
        }

        const response = await axios.get(
            `${GRAVATAR_API_BASE}${profileIdentifier}`
        );
        let { display_name, avatar_url, profile_url } = response.data;

        if (avatar_url) {
            try {
                const sep = avatar_url.includes('?') ? '&' : '?';
                await axios.head(`${avatar_url}${sep}d=404`);
            } catch (probeError) {
                if (probeError.response && probeError.response.status === 404) {
                    avatar_url = undefined;
                } else {
                    console.error('Error probing avatar image:', probeError);
                }
            }
        }

        const profileData = {
            display_name,
            avatar_url,
            profile_url,
        };

        localStorage.setItem(
            cacheKey,
            JSON.stringify({ profile: profileData, timestamp: Date.now() })
        );

        return profileData;
    } catch (error) {
        console.error('Failed to fetch Gravatar profile:', error);
        return undefined;
    }
}
